import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { colors } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { reFormatDate } from "../../../../../utils/utils";

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 650,
  },
}));

export default function SadadInvoicesTable(props) {
  const { data, isPurches} = props;


  const stylH={
   // borderWidth: 1,
    border: "solid 0.6px",
    borderColor: "black",
    borderStyle: "solid",
    fontFamily: "Amiri-Regular",
    fontWeight: 700,
    fontSize: 15,
    color:"#fff"
  }
  const stylRo={
    BorderBottom: "solid 0.5px",
    //borderStyle: "solid",
    borderColor: "gray",
    fontFamily: "Amiri-Regular",
    fontWeight: 700,
    fontSize: 14,
    color:"#000"
  }
  
  const { t } = useTranslation(["forms"]);
  const classes = useStyles();
  return (
    <TableContainer component={Paper} >
      <Table 
      //className={classes.table} 
      size="small" aria-label="a dense table" >
        <TableHead>
          <TableRow
            style={{
              backgroundColor: isPurches ? colors.blue[300] : colors.green[300],
              color: "#000",
              fontWeight: 800,
              fontFamily: "Amiri-Regular",
              fontSize: 15,
              border: "solid 0.6px"
            }}
          >
            <TableCell style={stylH} align="center">
              {t("invoice-id")}
            </TableCell>
            <TableCell style={stylH} align="center">
              {t("invoice-date")}
            </TableCell>
             <TableCell style={stylH} align="center">
              {t("time")}
            </TableCell>
            <TableCell style={stylH} align="center">
              {"توع الفاتورة"}
            </TableCell>
           
            <TableCell style={stylH} align="center">
              {isPurches ? "المورد" : "العميل"}
            </TableCell>
            <TableCell style={stylH} align="center">
              {t("invoice-amount")}
            </TableCell>
            <TableCell style={stylH} align="center">
              {t("paid")}
            </TableCell>
            <TableCell style={stylH} align="center">
              {t("remaining")}
            </TableCell>
            <TableCell style={stylH} align="center">
              {t("payment")}
            </TableCell>
            <TableCell style={stylH} align="center">
              {t("payment-status")}
            </TableCell>
            {/* <TableCell style={stylH} align="center">  </TableCell> */}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row,i) => (
            <TableRow key={row.title}
            style={{ padding: "5px 0px",
                textAlign: "-webkit-center",
                margin: "0px",
                whiteSpace: "nowrap",
                color: "#000",
                fontWeight: 800,
                fontFamily: "Amiri-Regular",
                fontSize: 15,
                border: "solid 0.6px"}}>
              <TableCell  style={stylRo} align="center" >{row.id}</TableCell>
              <TableCell style={stylRo} align="center" >{reFormatDate(row.date)}</TableCell>
              <TableCell style={stylRo} align="center" >{row.time}</TableCell>
              <TableCell style={stylRo} align="center"> {row.inv_type == 1 ? "اجل" : "نقدي"}</TableCell>
              <TableCell  style={stylRo} align="center" >{row.cust_name}</TableCell>
              <TableCell  style={stylRo} align="center" >{row.netAmount?.toFixed(2)}</TableCell>

              <TableCell style={stylRo} align="center" > { (parseFloat(row.cash_part)+parseFloat(row.network_part)+parseFloat(row.bank_part))?.toFixed(2)}</TableCell>

              <TableCell  style={stylRo} align="center" >{row.agel_part?.toFixed(2)}</TableCell>
              <TableCell  style={stylRo} align="center" >{row.AllocatedPayment?.toFixed(2)}</TableCell>
              <TableCell  style={stylRo} align="center" >{row.AllocatedPayment==row.netAmount?"تم السداد" :row.AllocatedPayment<row.netAmount && row.AllocatedPayment>0?"سداد جزء": "لم يتم"}</TableCell>
              {/* <TableCell  style={stylRo} align="center" ></TableCell> */}


            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
